interface ControlData {
  sensitivity?: number;
  specificity?: number;
  prevalence?: number;
  [key: string]: any;
}

interface StatusData {
  Status: string;
}

const updateFunc = (controlData: ControlData): StatusData[] => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;

  const h = 1000 - prevalence;
  const d = prevalence;
  const fp = 100 - specificity;
  const tp = sensitivity;
  const fpr = fp / 100;
  const tpr = tp / 100;
  const afp = fpr * h;
  const atp = tpr * d;

  const jsonTruePositiveActual: StatusData = { Status: "True positive" };
  const jsonFalsePositiveActual: StatusData = { Status: "False positive" };
  const jsonRemaining: StatusData = { Status: "." };
  const repeatedTruePositiveActual = Array(Math.round(atp)).fill(
    jsonTruePositiveActual
  );
  const repeatedFalsePositiveActual = Array(Math.round(afp)).fill(
    jsonFalsePositiveActual
  );
  const repeatedRemaining = Array(Math.round(1000 - atp - afp)).fill(
    jsonRemaining
  );
  let calculatedData = repeatedTruePositiveActual.concat(
    repeatedFalsePositiveActual
  );
  calculatedData = calculatedData.concat(repeatedRemaining);

  return calculatedData;
};

export default updateFunc;
